<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
    <v-alert dense outlined type="error" v-if="error">
      <ul>
        <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
      </ul>
    </v-alert>
    <v-row>
      <v-col md="12" cols="12">
        <v-text-field
          :label="$t('string690')"
          :rules="reqRules"
          hide-details="auto"
          v-model="data.accountHolderName"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" cols="12">
        <v-text-field
          :label="renderPlaceHolder()"
          :rules="reqRules"
          hide-details="auto"
          v-model="data.accountNumber"
          outlined
        ></v-text-field>
      </v-col>
      <v-col md="6" cols="12">
        <v-text-field
          :label="$t('RoutingNumber')"
          :rules="reqRules"
          hide-details="auto"
          v-model="data.abartn"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" v-if="editAccount">
        <v-btn
          large
          color="grey"
          class="mt-2"
          dark
          @click="emitEditChange"
          block
          rounded
        >
          <span class="mr-2">{{ $t("Cancel") }}</span>
        </v-btn>
      </v-col>
      <v-col>
        <v-btn large color="blue" dark block rounded type="submit" class="mt-2">
          <span class="mr-2">{{
            $t(editAccount ? "AddAccount" : "SetuppPayout")
          }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-form>
</template>

<script>
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import PartnerService from "@/services/PartnerService";
import swal from "sweetalert";

export default {
  name: "StripeUSComponent",
  props: ["editAccount", "accountData"],
  components: { WaitDialogComponent },
  data() {
    return {
      error: null,
      valid: null,
      waitDialog: false,
      reqRules: [value => !!value || this.$t("string719")],
      data: {
        country: "US",
        currency: "USD",
        user: this.$store.state.user.id,
        accountHolderName: this.accountData.accountHolderName || null,
        accountNumber: null,
        abartn: this.accountData.abartn || null
      }
    };
  },
  methods: {
    renderPlaceHolder() {
      if (this.accountData.accountNumber) {
        return `${this.$t("AccountNumber")} ${this.$t("EndingWith")} (${
          this.accountData.accountNumber
        }) ${this.$t("NeedReenter")}`;
      }
      return this.$t("AccountNumber");
    },
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        PartnerService.setupPayout(this.data)
          .then(result => {
            if (this.editAccount) {
              this.waitDialog = false;
              this.emitEditChange();
              swal({
                icon: "success",
                text: result.data.message,
                button: {
                  text: this.$t("Close"),
                  className: "swal-close"
                }
              });
            } else window.location.href = result.data.item.url;
            this.waitDialog = false;
          })
          .catch(err => {
            this.waitDialog = false;
            this.error = err.response.data.errors;
          });
      }
    },
    emitEditChange() {
      this.$emit("changeEdit");
    }
  }
};
</script>

<style></style>
